import qs from 'query-string';

import {fetchWithState, getFetchedJSON, fetchWithStateAndFile} from '~/misc/fetch';

export const logIn = (getState, login, password) =>
  fetchWithState(getState, {
    method: 'POST',
    url: '/tl/login',
    header: {
      'Content-Type': 'application/json',
    },
    // body: qs.stringify({login, password, grant_type: 'password'}),
    body: { email: login, password, grant_type: 'password' },
  })
    .then(getFetchedJSON)
    .then(res => res.data);

    
export const getUser = (getState) =>
  fetchWithState(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: '/tl/users/me',
  }).then(getFetchedJSON);

export const getW9form = (getState) => 
  fetchWithState(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: '/tl/users/me/fast',
  }).then(getFetchedJSON);

export const getW9formInfo = (getState, id, token) => 
  fetchWithState(getState, {
    url: `/tl/verification/w9form/user/info`,
    method: 'GET',
    header: {
      userId: id,
      'auth-token':token,
    },
  }).then(getFetchedJSON);

export const uploadW9form = (getState, id, token, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("source","TL")
  return fetchWithStateAndFile(getState, {
    url: `/tl/verification/file/upload`,
    method: 'POST',
    header: {
      userId: id,
      'auth-token':token,
    },
    body: formData
  }).then(getFetchedJSON);
}

export const uploadW9formByEmail = (getState, token, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("source","TL")
  return fetchWithStateAndFile(getState, {
    url: `/tl/verification/file/upload/no/user`,
    method: 'POST',
    header: {
      'sign': decodeURIComponent(token)
    },
    body: formData
  }).then(getFetchedJSON);
}

export const uploadInfo = (getState, id, token, files) => {
  return fetchWithState(getState, {
    url: `/tl/verification/w9form/add`,
    method: 'POST',
    header: {
      userId: id,
      'auth-token':token,
    },
    body: {...files, source: "web"}
  }).then(getFetchedJSON);
}

export const uploadInfoForLoadsmart = (getState, id, token, files) => {
  return fetchWithState(getState, {
    url: `/tl/verification/w9form/loadsmart/onboarding`,
    method: 'POST',
    header: {
      userId: id,
      'auth-token':token,
    },
    body: {...files, source: "web"}
  }).then(getFetchedJSON);
}

export const getInfoForLoadsmart = (getState, id, token) => {
  return fetchWithState(getState, {
    url: `/tl/loadsmart/onboarding`,
    method: 'POST',
    header: {
      userId: id,
      'auth-token': token,
    },
  }).then(getFetchedJSON);
};

export const uploadInfoFromEmailByAnon = (getState, token, files) => {
  return fetchWithState(getState, {
    url: `/tl/verification/w9form/verify/l1/succ/add`,
    method: 'POST',
    body: {...files, source: "web", token}
  }).then(getFetchedJSON);
}
export const uploadInfoFromEmail = (getState, id, token, files) => {
  return fetchWithState(getState, {
    url: `/tl/verification/w9form/add`,
    method: 'POST',
    header: {
      userId: id,
      'auth-token':token,
    },
    body: {...files, source: "Email-Campaign"}
  }).then(getFetchedJSON);
}



export const signUp = (getState, email, password, dot, mc) =>
  fetchWithState(getState, {
    method: 'POST',
    url: '/tl/signup?welcome_email=web_carriers_welcome',
    body: {
      email,
      password,
      dot: dot ? dot : null,
      mc: mc ? mc : null,
      source: 'webcarriers',
    },
  }).then(getFetchedJSON);

export const signUpV2 = (getState, email, password, firstName, lastName, phone, type, authNumber, source) =>
fetchWithState(getState, {
  method: 'POST',
  url: '/tl/signup?welcome_email=web-carriers-welcome',
  body: {
    email,
    password,
    first_name: firstName,
    last_name: lastName,
    phone: {
      number: phone,
      ext: '+1',
    },
    dot: type === 'us' ? authNumber : null,
    mc: type === 'mc' ? authNumber : null,
    source: source === '' ? 'webcarriers' : source,
  },
}).then(getFetchedJSON);

export const signUpInWelcome = (getState, {email, password, firstName, lastName, phone, dot, mc, companyName}) =>
fetchWithState(getState, {
  method: 'POST',
  url: '/tl/signup/email-campaign',
  body: {
    email,
    password,
    first_name: firstName,
    last_name: lastName,
    phone: {
      number: phone,
      ext: '+1',
    },
    dot, mc,
    company: {
      name : companyName
    },
    source:'tl-email-campaign'
  },
}).then(getFetchedJSON);

export const resetPassword = (getState, email) =>
  fetchWithState(getState, {
    method: 'POST',
    url: '/password_restore',
    body: qs.stringify({email}),
  });

export const changePassword = (getState, val) => {
  const userId = getState().user.id;
  const email = getState().user.email;
  val.email = email;
  return fetchWithState(getState, {
    method: 'PUT',
    url: `/users/${userId}/password`,
    body: qs.stringify(val),
  });
};

export const patchUser = (getState, id, data) =>
  fetchWithState(getState, {
    url: `/users/${id}`,
    method: 'PATCH',
    body: data,
  }).then(getFetchedJSON);


export const getW9fromInfoByEmail = (getState, token) =>
  fetchWithState(getState, {
    url: `//tl/verification/w9form/verify/l1/upload/status`,
    header: {
      'sign': decodeURIComponent(token)
    },
    method: 'GET',
  }).then(getFetchedJSON);

export const getDotMc = (getState, {dot, mc}) =>
  fetchWithState(getState, {
    url: `/tl/check/dot/mc`,
    method: 'POST',
    body: {
      dot, mc
    }
  }).then(getFetchedJSON);

export const getSetAlertSetting = (getState) => 
  fetchWithState(getState, {
    url: `/tl/user/extra/field`,
    method: 'GET',
  }).then(getFetchedJSON);

export const setSetAlert = (getState, flag) => 
  fetchWithState(getState, {
    url: `/tl/user/extra/field`,
    method: 'POST',
    body: {
      field: "is_select_carrier_search",
      field_value: String(flag)  
    }
  }).then(getFetchedJSON);

export const setSetAlertPoped = (getState, flag) => 
  fetchWithState(getState, {
    url: `/tl/user/extra/field`,
    method: 'POST',
    body: {
      field: "is_carrier_popup_window",
      field_value: String(flag)  
    }
  }).then(getFetchedJSON);


// WEBPACK FOOTER //
// ./src/modules/user/api.js